import 'mdn-polyfills/NodeList.prototype.forEach';

const triggers = document.querySelectorAll('.js-expand__trigger');

// Expand when trigger is clicked, and focus an element:
triggers.forEach(function(trigger) {
  trigger.addEventListener('click', function(event) {
    event.target.closest('.js-expand').classList.toggle('is-expanded');
    event.preventDefault();
  });
});
